// extracted by mini-css-extract-plugin
export default {"wrapper":"Container_wrapper__GaA+5"};